import { render, staticRenderFns } from "./GenerateFileLink.vue?vue&type=template&id=c2747b28"
import script from "./GenerateFileLink.vue?vue&type=script&lang=js"
export * from "./GenerateFileLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports